import React, { useState } from "react";
import { Title } from "rbx";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { GET_ASSIGNED_FOLLOWUPS } from "./graphql";
import "../Reviews/Reviews.scss";
import { Loader, DetailedDataTable } from "../../components";
import { ASSIGNED_FOLLOWUPS_COLUMNS } from "./columns";
import checkMobile from "../../utils/checkForMobile";
import { useCurrentUser } from "../../hooks";

const AssignedFollowups = () => {
  const currentUser = useCurrentUser();
  const [paginationWhere, setPaginationWhere] = useState({}); // eslint-disable-line
  
  const { data: assignedFollowupsData, loading } = useQuery(GET_ASSIGNED_FOLLOWUPS, {
    variables: {
      where: {
        assignedToUser: {
          is: {
            employeeNumber: {
              equals: currentUser?.employeeNumber
            }
          }
        }
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const assignedFollowups = assignedFollowupsData?.userFollowups || [];
  const isMobile = checkMobile();

  const history = useHistory();

  const handleAssignedFollowupClick = (row) => {
    history.push(`/followups/${row.user.employeeNumber}`);
  };

  if (loading) {
    return (
      <div className={isMobile ? "workshop-container-mobile" : "workshop-container"}>
        <div className="loader-container">
          <Loader />
        </div>
      </div>
    );
  }

  if (!assignedFollowups?.length > 0) {
    return (
      <div className={isMobile ? "workshop-container-mobile" : "workshop-container"}>
        <div className="workshop">
          <Title>No Follow-ups Assigned to You</Title>
        </div>
      </div>
    );
  }

  return (
    <div className={isMobile ? "workshop-container-mobile" : "workshop-container"}>
      <div className="workshop">
        <Title>Follow-ups Assigned to Me</Title>
        <DetailedDataTable
          aggregateName="aggregateUserFollowup"
          columns={ASSIGNED_FOLLOWUPS_COLUMNS}
          dataExtractor={(data) => data?.userFollowups}
          defaultSorting={[{ id: "title", desc: false }]}
          location="assigned-followups"
          name="assigned-followups"
          query={GET_ASSIGNED_FOLLOWUPS}
          searchTransformer={(search) => ({})}
          setPaginationWhere={setPaginationWhere}
          totalExtractor={(total) => total}
          where={{
            assignedToUser: {
              is: {
                employeeNumber: {
                  equals: currentUser?.employeeNumber
                }
              }
            }
          }}
          onRowClick={(followup) => handleAssignedFollowupClick(followup)}
        />
      </div>
    </div>
  );
};

export default AssignedFollowups; 